import { render, staticRenderFns } from "./DenunciationsQuestions.vue?vue&type=template&id=4b291e5e&scoped=true&"
import script from "./DenunciationsQuestions.vue?vue&type=script&lang=js&"
export * from "./DenunciationsQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsQuestions.vue?vue&type=style&index=0&id=4b291e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b291e5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
